import {isLinkActive} from "./Sidebar.shared";
import {NavLink, generatePath} from "react-router-dom";
import {MenuItem} from "react-pro-sidebar";

/**
 * @param {string} [icon]
 * @param {string} label
 * @param {string} url
 * @param {Record<string, any>} [urlParams]
 * @param {string} [className]
 * @param {(e) => void} [onClick]
 * */
export function MenuNavItem({ icon, url, urlParams = {}, label, className, onClick = (e) => void null }) {

    // generatePath
    return (
        <MenuItem icon={icon == null ? '' : (<img src={icon} alt="icon" />)} active={isLinkActive(url)} onClick={onClick} className={className}>
            <NavLink className="nav-link" to={generatePath(url, urlParams)}>{label}</NavLink>
        </MenuItem>
    );
}
